import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { BsModalService } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';

import { TransferChallanOutService, CommonService, ClientWalkInService, SubscribeService, BranchService } from '../../../services/index';
import { TransferChallanOutModal } from '../../../model/index';

import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';

@Component({
    selector: 'add-transfer-challan-out-tab',
    templateUrl: './addTransferChallanOut.component.html'
})
export class AddTransferChallanOutComponent implements OnInit {
    viewData: any[];
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    //@Input() params;
    _params: any[] = [];
    @Input() set params(val: any[]) {
        this._params = val;
        this.setPageData();
    }
    public mode: string;
    branchCtrl: FormControl;
    outTypeCtrl: FormControl;
    hvUserCtrl: FormControl;
    modelTypeCtrl: FormControl;
    outTypeList: string[] = ['Branch', 'HV Team'];
    modelTypeList: string[] = ['HA MODEL', 'Spare'];
    branchList: any[] = [];
    hvUserList: any[];
    haList: any[] = [];
    columns = [];
    toggleCol = [];
    filterData = {
        "search_data": ""
    };
    filteredHvuserlist: Observable<any[]>;
    filteredBranch: Observable<any[]>;
    filteredSerialNo: Observable<any[]>;
    serialNoCtrl: FormControl;
    halistCtrl: FormControl;
    filteredHa: Observable<any[]>;
    serialNoList: any[] = [];
    actSerialNoList = [];
    filteredBrandModel: Observable<any[]>;
    filteredBrand: Observable<any[]>;
    filteredFamily: Observable<any[]>;
    filteredSeries: Observable<any[]>;
    filteredPower: Observable<any[]>;
    filteredPerformance: Observable<any[]>;
    filteredBattery: Observable<any[]>;
    brandModelList$: any[] = [];
    brandModelCtrl: FormControl;
    brandList$: any[] = [];
    brandCtrl: FormControl;
    familyList$: any[] = [];
    seriesList$: any[] = [];
    powerList$: any[] = [];
    performanceList$: any[] = [];
    batteryList$: any[] = [];
    familyCtrl: FormControl;
    seriesCtrl: FormControl;
    powerCtrl: FormControl;
    performanceCtrl: FormControl;
    batteryCtrl: FormControl;
    //@Output() transferChellOutUpdateEvent = new EventEmitter();

    @Input() tcOutData: TransferChallanOutModal[] = [];
    @Input() tcOutRow: TransferChallanOutModal[] = [];
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('branchAutoComp') branchAutoComp;
    @ViewChild('halistAutoComp') halistAutoComp;

    isLoading: boolean = false;
    minDate: any;

    constructor(
        public store: Store<fromRootStore.State>,
        private modalService: BsModalService,
        public toasterService: ToasterService,
        private commonService: CommonService,
        private BranchService: BranchService,
        private tcOutService: TransferChallanOutService,
        private clientWalkInService: ClientWalkInService, public subscribeService: SubscribeService
    ) {
        this.getHVUserList();
        this.serialNoCtrl = new FormControl();
        this.filteredSerialNo = this.serialNoCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSerialNo(name) : this.serialNoList.slice());
        //this.getBranchList();
        function hasValidBranch(input: FormControl) {
            let branchID = input.value;
            let femp = _.find(this.branchList, { 'branch_id': branchID });
            if (femp)
                return null;
            return { inValidBranch: true };
        }
        //FOR AUTO COMPLETE VALIDATION --- ASSIGN TO LIST
        function hasValidHVUser(input: FormControl) {
            let statusID = input.value, retVal = null;
            if (statusID == "") {
                retVal = { inValidHVUser: true };
            }
            if (statusID && typeof statusID === 'string') {
                retVal = { inValidHVUser: true };
            }
            return retVal;
        }
        this.hvUserCtrl = new FormControl('', [
            Validators.required,
            hasValidHVUser.bind(this)
        ]);

        this.filteredHvuserlist = this.hvUserCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterHvUser(name) : this.hvUserList ? this.hvUserList.slice() : []);
            
        this.branchCtrl = new FormControl('', [
            Validators.required,
            hasValidBranch.bind(this)
        ]);
        this.filteredBranch = this.branchCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBranch(name) : this.branchList.slice());

        function hasValidOutType(input: FormControl) {
            if (this.outTypeList.indexOf(input.value) >= 0)
                return null;
            else
                return { inValidOutType: true };
        }
        function hasValidModelType(input: FormControl) {
            if (this.modelTypeList.indexOf(input.value) >= 0)
                return null;
            else
                return { inValidModelType: true };
        }
      
        this.outTypeCtrl = new FormControl('', [
            Validators.required,
            hasValidOutType.bind(this)
        ]);
      
        this.modelTypeCtrl = new FormControl('', [
            Validators.required,
            hasValidModelType.bind(this)
        ]);

        function hasValidHaModel(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidHaModel: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidHaModel: true };
            }
            return retVal;
        }
        this.halistCtrl = new FormControl('', [
            Validators.required,
            hasValidHaModel.bind(this)
        ]);
        //  this.halistCtrl = new FormControl();
        this.filteredHa = this.halistCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterHa(name) : this.haList.slice());

        //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidBrandModel(input: FormControl) {
            let brandModelID = input.value, retVal = null;
            if (brandModelID == "") {
                retVal = { inValidBrandModel: true };
            }
            if (brandModelID && typeof brandModelID === 'string') {
                retVal = { inValidBrandModel: true };
            }
            return retVal;
        }
        this.brandModelCtrl = new FormControl('', [
            Validators.required,
            hasValidBrandModel.bind(this)
        ]);
        this.filteredBrandModel = this.brandModelCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBrandModel(name) : this.brandModelList$.slice());
        //FOR AUTO COMPLETE VALIDATION --- BRAND COMBO
        function hasValidBrand(input: FormControl) {
            let brandID = input.value, retVal = null;
            if (brandID == "") {
                retVal = { inValidBrand: true };
            }
            if (brandID && typeof brandID === 'string') {
                retVal = { inValidBrand: true };
            }
            return retVal;
        }
        this.brandCtrl = new FormControl('', [
            Validators.required,
            hasValidBrand.bind(this)
        ]);
        this.filteredBrand = this.brandCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBrand(name) : this.brandList$.slice());

        //FOR AUTO COMPLETE VALIDATION --- FAMILY COMBO
        function hasValidFamily(input: FormControl) {
            let familyID = input.value, retVal = null;
            if (familyID == "") {
                retVal = { inValidFamily: true };
            }
            if (familyID && typeof familyID === 'string') {
                retVal = { inValidFamily: true };
            }
            return retVal;
        }
        this.familyCtrl = new FormControl('', [
            Validators.required,
            hasValidFamily.bind(this)
        ]);
        this.filteredFamily = this.familyCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterFamily(name) : this.familyList$.slice());
        
        //Series
        function hasValidSeries(input: FormControl) {
            let seriesID = input.value, retVal = null;
            if (seriesID && typeof seriesID === 'string') {
                retVal = { inValidSeries: true };
            }
            return retVal;
        }
        this.seriesCtrl = new FormControl('', hasValidSeries.bind(this));

        this.filteredSeries = this.seriesCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSeries(name) : this.seriesList$.slice());

        //Performance
        function hasValidPerformance(input: FormControl) {
            let performanceID = input.value, retVal = null;
            if (performanceID && typeof performanceID === 'string') {
                retVal = { inValidPerformance: true };
            }
            return retVal;
        }
        this.performanceCtrl = new FormControl('', hasValidPerformance.bind(this));

        this.filteredPerformance = this.performanceCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterPerformance(name) : this.performanceList$.slice());

        //Power
        function hasValidPower(input: FormControl) {
            let powerID = input.value, retVal = null;
            if (powerID && typeof powerID === 'string') {
                retVal = { inValidPower: true };
            }
            return retVal;
        }
        this.powerCtrl = new FormControl('', hasValidPower.bind(this));
        this.filteredPower = this.powerCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterPower(name) : this.powerList$.slice());

        //Battery
        function hasValidBattery(input: FormControl) {
            let batteryID = input.value, retVal = null;
            if (batteryID && typeof batteryID === 'string') {
                retVal = { inValidBattery: true };
            }
            return retVal;
        }
        this.batteryCtrl = new FormControl('', hasValidBattery.bind(this));
        this.filteredBattery = this.batteryCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBattery(name) : this.batteryList$.slice());

    }

    reorderable: boolean = true;

    page = {
        limit: 50,
        count: 0,
        offset: 0,
        orderBy: 'model_id',
        orderDir: 'asc'
    };

    tcOutList = [];

    ngOnInit(): void {

        let that = this;
        // this.loadChallanHaList();
        this.halistAutoComp.optionSelected.subscribe(this.onSelectedHaList.bind(this));


        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, sortable: false, cellTemplate: this.snoTemplate, toggle: true },
            { name: 'Model', prop: 'name', width: 220, minWidth: 220, maxWidth: 220, toggle: true },
            { name: 'Serial No', prop: 'serial_no', width: 140, minWidth: 140, maxWidth: 140, toggle: true },
            { name: 'Brand', prop: 'brand_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Brand Model', prop: 'brand_model_name',width:140,minWidth:140, maxWidth: 140, sortable: false, cellClass: 'cell-left' },
            { name: 'Family', prop: 'family_name',width:80,minWidth:80, maxWidth: 80, sortable: false, cellClass: 'cell-left' },
            { name: 'Series', prop: 'series_name',width:80,minWidth:80, maxWidth: 80, sortable: false, cellClass: 'cell-left' },
            { name: 'Performance', prop: 'performance_name',width:150,minWidth:150, maxWidth: 150, sortable: false, cellClass: 'cell-left' },
            { name: 'Power', prop: 'power_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Battery', prop: 'battery_name',width:100,minWidth:100, maxWidth: 100, sortable: false, cellClass: 'cell-left' },
            { name: 'Color', prop: 'color_name', width: 120, minWidth: 120, maxWidth: 120, sortable: false, cellClass: 'cell-left' },
            { name: 'Tele Audiology', prop: 'tele_audiology',width:120,minWidth:120, maxWidth: 120, sortable: false, cellClass: 'cell-left' },
            { name: 'MRP', prop: 'mrp', width: 80, minWidth: 80, maxWidth: 80, toggle: true },
            { name: 'Qty', prop: 'qty', width: 90, minWidth: 90, maxWidth: 90, toggle: true, cellClass: 'cell-right' },
            { name: 'Action', prop: 'action', width: 80, minWidth: 80, maxWidth: 80, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];
        this.toggleCol = Object.assign({}, this.columns);

        if (this._params['mode'] == 'Add') {
            this.minDate = new Date(new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate());
            this.tcOutData['date'] = new Date();

            this.getAutoNumber();
        }
        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                //this.store.dispatch(new commonActions.LoadAllBrand());
                //this.brandList$ = res;
                return;
            }
            this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
                if (auth['islogin']) {
                    let branchs = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' && obj['is_hv_center'] == 'false'});
                    that.branchList = _.filter(branchs, function (obj) { return obj['branch_id'] && obj['store_branch'] == 'Yes'});
                    if (that._params['return_id'] && that._params['mode'] == 'Add') {
                        that.branchCtrl.setValue(8);
                    }
                }
            });
        });

        this.store.select(fromCommonStore.getAllBrandModel).subscribe((res: any) => {
            if (_.isEmpty(res)) {
                //this.store.dispatch(new commonActions.LoadAllBrandModel());
                //this.brandModelList$ = res;
                return;
            }
            this.brandModelList$ = res;
        });
        this.store.select(fromCommonStore.getAllBrand).subscribe((res: any) => {
            if (_.isEmpty(res)) {
                //this.store.dispatch(new commonActions.LoadAllBrandModel());
                //this.brandList$ = res;
                return;
            }
            this.brandList$ = res;
        });
    }

    loadFamilyList() {
        let that = this;
        this.commonService
            .getFamilyList()
            .then(function(res: any) {
                // that.familyList$ = res.data;
                const familydata = res.data.filter(item => item.brand_id === that.tcOutRow['brand_id']);
                that.familyList$ = familydata;
                that.familyCtrl.setValue(that.tcOutRow['family_id']);
            });
    }

    //BRAND MODEL
    filterBrandModel(name: string) {
        name = _.escapeRegExp(name);
        return this.brandModelList$.filter(item => (new RegExp(name, 'gi').test(item.disp_name)));
    }
    displayBrandModelFn(modelID: number) {
        if (modelID && this.brandModelList$.length > 0) {
            let fitem = _.find(this.brandModelList$, { 'model_id': modelID });
            this.tcOutRow['brand_model_name'] = fitem['disp_name'];
            return fitem['disp_name'];
        }
        return '';
    }
    //BRAND
    filterBrand(name: string) {
        name = _.escapeRegExp(name);
        return this.brandList$.filter(item => (new RegExp(name, 'gi').test(item.name)));
    }
    displayBrandFn(brandID: number) {
        if (brandID && this.brandList$.length > 0) {
            let fitem = _.find(this.brandList$, { 'brand_id': brandID });
            this.tcOutRow['brand_name'] = fitem['name'];
            return fitem['name'];
        }
        return '';
    }
    //FAMILY
    filterFamily(name: string) {
        name = _.escapeRegExp(name);
        return this.familyList$.filter(item => (new RegExp(name, 'gi').test(item.family_name)));
    }
    displayFamilyFn(familyID: number) {
        if (familyID && this.familyList$.length > 0) {
            let fitem = _.find(this.familyList$, { 'family_id': familyID });
            this.tcOutRow['family_name'] = fitem['family_name'];
            return fitem['family_name'];
        }
        return '';
    }

    onChangeFamily(){
        this.loadFamilyList();
        this.loadAllList();
    }

    //Series
    filterSeries(name: string) {
        name = _.escapeRegExp(name);
        return this.seriesList$.filter(item => (new RegExp(name, 'gi').test(item.series_name)));
    }
    displaySeriesFn(seriesID: number) {
        if (seriesID && this.seriesList$.length > 0) {
            let seriesitem = _.find(this.seriesList$, { 'series_id': seriesID });
            this.tcOutRow['series_name'] = seriesitem['series_name'];
            return seriesitem['series_name'];
        }
        return '';
    }

     //Performance
     filterPerformance(name: string) {
        name = _.escapeRegExp(name);
        return this.performanceList$.filter(item => (new RegExp(name, 'gi').test(item.performance_name)));
    }
    displayPerformanceFn(performanceID: number) {
        if (performanceID && this.performanceList$.length > 0) {
            let performanceitem = _.find(this.performanceList$, { 'performance_id': performanceID });
            this.tcOutRow['performance_name'] = performanceitem['performance_name'];
            return performanceitem['performance_name'];
        }
        return '';
    }

    //Power
    filterPower(name: string) {
        name = _.escapeRegExp(name);
        return this.powerList$.filter(item => (new RegExp(name, 'gi').test(item.power_name)));
    }
    displayPowerFn(powerID: number) {
        if (powerID && this.powerList$.length > 0) {
            let poweritem = _.find(this.powerList$, { 'power_id': powerID });
            this.tcOutRow['power_name'] = poweritem['power_name'];
            return poweritem['power_name'];
        }
        return '';
    }

    //Battery
    filterBattery(name: string) {
        name = _.escapeRegExp(name);
        return this.batteryList$.filter(item => (new RegExp(name, 'gi').test(item.battery_name)));
    }
    displayBatteryFn(batteryID: number) {
        if (batteryID && this.batteryList$.length > 0) {
            let batteryitem = _.find(this.batteryList$, { 'battery_id': batteryID });
            this.tcOutRow['battery_name'] = batteryitem['battery_name'];
            return batteryitem['battery_name'];
        }
        return '';
    }

    loadAllList() {
        let that = this;
        //to get series list
        this.commonService
            .getAllList()
            .then(function(res: any) {
                const seriesdata = res.data.filter(item => item.brand_id === that.tcOutRow['brand_id']);
                that.seriesList$ = seriesdata;
                that.seriesCtrl.setValue(that.tcOutRow['series_id']);

                const powerdata = res.powerdata.filter(item => item.brand_id === that.tcOutRow['brand_id']);
                that.powerList$ = powerdata;
                that.powerCtrl.setValue(that.tcOutRow['power_id']);

                const performancedata = res.performancedata.filter(item => item.brand_id === that.tcOutRow['brand_id']);
                that.performanceList$ = performancedata;
                that.performanceCtrl.setValue(that.tcOutRow['performance_id']);

                // const batterydata = res.batterydata.filter(item => item.brand_id === that.tcOutRow['brand_id']);
                that.batteryList$ = res.batterydata;
                that.batteryCtrl.setValue(that.tcOutRow['battery_id']);

            });  
    }
    
    getAutoNumber() {
        let that = this,
            tcOutDate = moment(this.tcOutData['date']).format('YYYY-MM-DD'),
            params = {
                account_type: 'transferChallanOut',
                date: tcOutDate,
            };
        this.commonService.getAutoNumber(params)
            .then(function (res: any) {
                that.tcOutData['tc_no'] = res['auto_no'];
            });
    }
    getHVUserList() {
        let that = this;
        let data = {
            fol_id: 1
        };
        that.commonService
            .getHVUserList(data)
            .then(function (res: any) {
                if (res && res.data && res.data.length) {
                    that.hvUserList = res.data;
                    if (that.mode != 'Add') {
                        that.hvUserCtrl.setValue(that._params['hv_userid']);
                    }
                }
            });
    }
    onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }
    addEditTcOut() {
        let firstform = this.tcOutData;
        let secformdet = this.tcOutRow;
        let avail = secformdet['avail_qty'],
            qty = secformdet['qty'],
            mode = secformdet['mode'],
            modelID = secformdet['model_id'],
            modelName = secformdet['name'],
            serialNo = secformdet['serial_no'];


        if (qty == null || avail == "" || qty == 0) {
            swal(
                'ERROR',
                'Please Enter The Qty',
                'error'
            );

            return false;
        }

        if (parseFloat(qty) > parseFloat(avail)) {
            swal(
                'ERROR',
                'Please Enter Valid Qty',
                'error'
            );
            return false;
        }


        //if (!_.isEmpty(modelID)) {//} != undefined) {
        //IF preTestID FOUND, THAT ID IS ALREDAY AVAILABLE INSIDE TABLE
        let preTestID = _.find(this.tcOutList, { 'model_id': modelID, 'serial_no': serialNo });

        if (preTestID) {
            swal('WARNING', 'Model : ' + modelName + ', Serial NO: ' + serialNo + ' Already Exists');
            return;
        }
        //TO CHECK STOCK AVAILABLE
        /* let modelObj = _.find(this.tcOutRow, { 'model_id': modelID });
         if (_.isEmpty(modelObj)) {
             swal('WARNING', 'Model : ' + modelName + ' Not Exists');
             return;
         }*/
        //TO CHECK SERIAL NO EXISTS IN THAT MODEL
        let actSerialNoList = this.actSerialNoList,
            currSerialNoObj = _.find(actSerialNoList, { 'model_id': modelID, 'serial_no': serialNo });
        if (_.isEmpty(currSerialNoObj)) {
            swal('WARNING', 'Serial No : ' + serialNo + ' Does Not  Exists in This Model');
            return;
        }

        let availQty = this.tcOutRow['avail_qty'],
            enteredQty = this.tcOutRow['quantity'];
        if (_.toNumber(enteredQty) > _.toNumber(availQty)) { // 11 > 10
            swal('WARNING', 'Model : ' + modelName + ' does not have Sufficient Quantity in Stock');
            return;
        }
        if (this.tcOutRow['hide_col'] == true) {
            swal('WARNING', 'Previous Advance Bill is in Progress, so You can not Add Any Model to this Transaction!');
            return;
        }
        if (firstform['btnTxt'] == 'Save') {
            let part = Object.assign({}, secformdet);
            this.tcOutList.push(part);
            if (this.tcOutData['is_reset_data']) {
                this.tcOutRow['serial_no'] = "";
            } else {
                this.tcOutRow = [];
            }

            this.page.count = this.tcOutList.length;

        } else {
            let that = this;
            let mainForm = this.tcOutData;
            let rowDet = this.tcOutRow;
            let item_id = rowDet['model_id'];
            let avail_qty = rowDet['avail_qty'];
            let curqty = rowDet['qty'];
            let tc_out_id = mainForm['tc_out_id'];
            let params = {
                itemid: item_id,
                availqty: avail_qty,
                qty: curqty,
                tcoutid: tc_out_id,
                serial_no: that.tcOutRow['serial_no'],
                mrp: that.tcOutRow['mrp'],
                model_type: that.tcOutRow['model_type'],
                particulars: Object.assign({}, rowDet)
                //from_branch: 1
            }
            let part = Object.assign({}, rowDet);
            this.tcOutList.push(part);
            this.tcOutRow = [];
            this.page.count = this.tcOutList.length;
            this.tcOutService
                .addRowInEdit(params)
                .then(function (res: any) {
                    that.isLoading = false;
                    if (res.success) {
                        swal('SUCCESS', res.message, 'success');
                        that.tcOutRow = [];
                        // that.getItemsList();
                        let data = {
                            company_id: that.tcOutData['company_id'],
                            tc_out_id: that.tcOutData['tc_out_id']
                        }
                        that.getEditTcOutDetails(data);
                    } else {

                        swal('ERROR', res.message, 'error');
                    }
                })

        }
    }


    deleteTcOutList(row: any): void {

        let that = this;

        let mode = this._params['mode'];
        if (this.tcOutRow['hide_col'] == true) {
            swal('WARNING', 'Previous Advance Bill is in Progress, so You can not Deleted Any Model in this Transaction!');
            return;
        }
        if (mode == 'Add') {

            this.tcOutList.splice(this.tcOutList.indexOf(row), 1);
            //  this.tcOutList = [];

        } else {
            let that = this;
            let params = {
                model_id: row.model_id,
                tc_out_id: row.tc_out_id,
                det_id: row.tc_out_detid,
                avail_qty: row.avail_qty,
                qty: row.qty,
                serial_no: row.serial_no
                //  from_branch: 1
            };
            this.tcOutList.splice(this.tcOutList.indexOf(row), 1);
            //this.tcOutList = [];

            this.tcOutService
                .deleteTcOutGridList(params)
                .then(function (res: any) {
                    that.isLoading = false;
                    if (res.success) {
                        swal('SUCCESS', res.message, 'success');

                        /*this.getEditTcOutDetails(row);*/
                        //  that.getItemsList();
                    } else {

                        swal('ERROR', res.message, 'error');
                    }
                })
        }


    }
    
    filterBranch(name: string) {
        name = _.escapeRegExp(name);
        return this.branchList.filter(ha => (new RegExp(name, 'gi').test(ha.branch_name)));
    }
    displayFn(branchID: any) {
        if (this.branchList != undefined) {
            if (branchID && this.branchList.length > 0) {
                if (typeof branchID == 'string') {
                    branchID = parseInt(branchID);
                }
                let fitem = _.find(this.branchList, { 'branch_id': branchID });
                //this.branchList['company_name'] = fitem.branchList; //ANOTHER FIELD
                return fitem['branch_name'];
            }
        }
        return '';

    }

    displayOutTypeFn(outType: any) {
        if (this.outTypeList != undefined && this.outTypeList.length > 0 && outType) {
            return this.outTypeList.indexOf(outType) >= 0 ? outType : '';
        }
        return '';

    }

    displayModelTypeFn(modelType: any) {
        if (this.modelTypeList != undefined && this.modelTypeList.length > 0 && modelType) {
            this.loadChallanHaList(modelType);
            return this.modelTypeList.indexOf(modelType) >= 0 ? modelType : '';
        }
        return '';

    }
    // HV User display
    filterHvUser(name: string) {
        name = _.escapeRegExp(name);
        return this.hvUserList.filter(ha => (new RegExp(name, 'gi').test(ha.fullname)));
    }
    assignFn(empid: any) {
        if (this.hvUserList != undefined) {
            if (empid && this.hvUserList.length > 0) {
                if (typeof empid == 'string') {
                    empid = parseInt(empid);
                }
                let fitem = _.find(this.hvUserList, { 'userid': empid });
                return fitem && fitem['fullname'] ? fitem['fullname'] : '';
            }
        }
        return '';

    }

    setPageData(): void {
        let that = this;
        if (this._params != undefined) {
            that.tcOutData = Object.assign({}, that._params);
            this.mode = this._params['mode'];
            if (this.mode == 'Edit') {
                let data = this._params;
                this.tcOutData = this._params;
                this.tcOutData['btnTxt'] = data['btnTxt'];
                this.tcOutData['date'] = new Date(this._params['tcout_date']);//new Date();
                this.outTypeCtrl.setValue(this._params['out_type']);
                that.branchCtrl.setValue(that._params['branch_id']);
                that.hvUserCtrl.setValue(that._params['hv_userid']);
                this.getEditTcOutDetails(data);
            } else if (this.mode == 'View') {
                let data = this._params;
                this.tcOutData = this._params;
                this.viewData = this._params;
                this.tcOutData['btnTxt'] = data['btnTxt'];
                this.tcOutData['date'] = new Date(this._params['tcout_date']);//new Date();
                this.outTypeCtrl.setValue(this._params['out_type']);
                that.branchCtrl.setValue(that._params['branch_id']);
                that.hvUserCtrl.setValue(that._params['hv_userid']);
                this.getEditTcOutDetails(data);
            } else {
                let data = this._params;
                this.tcOutData['btnTxt'] = data['btnTxt'];
                if (data['return_id']) {
                    this.tcOutData['out_type'] = 'Branch';
                    this.tcOutData['company_id'] = 8;
                    this.tcOutData['description'] = 'Machine Return - ' + (data['client_no'] || '') + ' - ' + (data['client_name'] || '');
                    this.outTypeCtrl.setValue('Branch');
                    this.branchCtrl.setValue(8);
                    if (data['return_items'] && data['return_items'].length > 0) {
                        this.tcOutList = data['return_items'].map(item => ({
                            model_id: item.details_id,
                            name: item.name,
                            serial_no: item.serial_no,
                            qty: item.qty,
                            mrp: item.mrp,
                            avail_qty: item.avail_qty || 0,
                            brand_id: item.brand_id || 0,
                            brand_model_id: item.brand_model_id || 0,
                            family_id: item.family_id || 0,
                            series_id: item.series_id || 0,
                            performance_id: item.performance_id || 0,
                            power_id: item.power_id || 0,
                            battery_id: item.battery_id || 0,
                            color_id: item.color_id || 0,
                            brand_name: item.brand_name || '',
                            brand_model_name: item.brand_model_name || '',
                            family_name: item.family_name || '',
                            series_name: item.series_name || '',
                            performance_name: item.performance_name || '',
                            power_name: item.power_name || '',
                            battery_name: item.battery_name || '',
                            color_name: item.color_name || '',
                            tele_audiology: item.tele_audiology || '',
                            model_type: 'HA MODEL'
                        }));
                        this.page.count = this.tcOutList.length;
                    }
                }
            }
        }
    }

    getEditTcOutDetails(data: any): void {

        let params = {
            company_id: data.company_id,
            tc_out_id: data.tc_out_id
        };

        let that = this;
        this.tcOutService
            .getEditDetails(params)
            .then(function (res: any) {

                that.page.count = res.totCnt;
                that.tcOutList = res.data;
            });
    }

    loadChallanHaList(model_type: string) {
        let that = this,
            data = {
                stock_type: model_type,
                from_page: 'TCO'
            };
        this.commonService
            .getHaModelStock(data)
            .then(function (res: any) {
                const uniqueArray = res['haStockModel'].filter((value, index, self) =>
                            index === self.findIndex((t) => (
                              t.model_id === value.model_id // Comparing the `id` field
                            ))
                        );
                that.haList = uniqueArray;//res['haStockModel'];
                that.actSerialNoList = res['haModelStockSerial'];
                // that.halistCtrl.setValue(that.tcOutRow['model_id']);
                that.halistCtrl.setValue('');
                that.serialNoCtrl.setValue('');
            });
    }

    filterHa(name: string) {
        name = _.escapeRegExp(name);
        return this.haList.filter(ha => (new RegExp(name, 'gi').test(ha.model_id) || new RegExp(name, 'gi').test(ha.name)));
    }

    displayHa(item_id: number) {

        if (item_id && this.haList.length > 0) {
            let fhalist = _.find(this.haList, { 'model_id': item_id });
            //this.challangriddata['avail_qty'] = fhalist.avail_qty;
            this.tcOutRow['brand_name'] = fhalist['brand_name'];
            this.tcOutRow['brand_model_name'] = fhalist['brand_model_name'];
            this.tcOutRow['family_name'] = fhalist['family_name'];
            this.tcOutRow['series_name'] = fhalist['series_name'];
            this.tcOutRow['performance_name'] = fhalist['performance_name'];
            this.tcOutRow['power_name'] = fhalist['power_name'];
            this.tcOutRow['battery_name'] = fhalist['battery_name'];
            this.tcOutRow['tele_audiology'] = fhalist['tele_audiology'];
            this.tcOutRow['brand_id'] = fhalist['brand_id'];
            this.tcOutRow['brand_model_id'] = fhalist['brand_model_id'];
            this.tcOutRow['family_id'] = fhalist['family_id'];
            this.tcOutRow['series_id'] = fhalist['series_id'];
            this.tcOutRow['performance_id'] = fhalist['performance_id'];
            this.tcOutRow['power_id'] = fhalist['power_id'];
            this.tcOutRow['battery_id'] = fhalist['battery_id'];
            this.tcOutRow['color_name'] = fhalist['color_name'];
            this.tcOutRow['color_id'] = fhalist['color_id'];
            this.getModelSerialNo(item_id);
            return fhalist['name'];
        }
        return '';
    }

    getModelSerialNo(modelID) {

        let actSerialNoList = this.actSerialNoList;
        this.serialNoList = _.filter(actSerialNoList, { 'model_id': modelID });
        this.serialNoCtrl.setValue(this.tcOutRow['serial_no']);
    }

    filterSerialNo(name: string) {
        name = _.escapeRegExp(name);
        return this.serialNoList.filter(ha => (new RegExp(name, 'gi').test(ha.serial_no)));
    }

    displaySerialNo(serial_no: number) {
        if (serial_no && this.serialNoList.length > 0) {
            let fhalist = _.find(this.serialNoList, { 'serial_no': serial_no });
            if (fhalist.model_id) {
                // this.challangriddata['mrp'] = fhalist.mrp;
                this.tcOutRow['model_id'] = fhalist.model_id;
                this.tcOutRow['serial_no'] = fhalist.serial_no;
                this.tcOutRow['mrp'] = fhalist.mrp;
                this.tcOutRow['avail_qty'] = fhalist.avail_qty;
                //this.challangriddata['quantity'] = 1;
                return fhalist['serial_no'];
            } else {
                return '';
            }
        }
        return '';
    }
    onSelectedHaList(mdCompEvent: any) {
        let model_id = mdCompEvent.option.value,
            fhalist = _.find(this.haList, { 'model_id': model_id });

        this.tcOutRow['name'] = fhalist.name;
    }

    // To check Challan Out Form is invalid
    hasInvalidChallanOutForm() {
        return (this.outTypeCtrl.errors && (this.outTypeCtrl.errors['inValidOutType'] || this.outTypeCtrl.errors['required']))
            || (this.tcOutData['out_type'] == 'HV Team' ? 
                (!this.tcOutData['hv_userid'] || (this.hvUserCtrl.errors && (this.hvUserCtrl.errors['inValidHVUser'] || !this.hvUserCtrl.errors['required'])))
                    : (!this.tcOutData['company_id'] || (this.branchCtrl.errors && (this.branchCtrl.errors['inValidBranch'] && !this.branchCtrl.errors['required']))));
    }

    onSaveTransferChellanOut() {
        let that = this;
        let rowDet = that.tcOutList;
        let tcFormDet = JSON.stringify(rowDet);
        let tcOutDet = that.tcOutData;
        let tcOutDate = moment(tcOutDet['date']).format('YYYY-MM-DD');


        if (rowDet.length == 0) {
            swal(
                'ERROR',
                'Please Enter Atleast One Details',
                'error'
            );
            return false;
        }
        if (tcOutDet['btnTxt'] == 'Save') {
            let params = {
                tcno: tcOutDet['tc_no'],
                out_type: tcOutDet['out_type'],
                companyid: tcOutDet['out_type'] !== 'HV Team' ? tcOutDet['company_id'] : 0,
                hv_userid: tcOutDet['out_type'] === 'HV Team' ? tcOutDet['hv_userid'] : 0,
                description: tcOutDet['description'] ? tcOutDet['description'] : '',
                tc_outdate: tcOutDate,
                return_id: this._params['return_id'] ? this._params['return_id'] : 0,
                particulars: tcFormDet,
                mode: 'Add'
            };
            this.isLoading = true;
            this.tcOutService.addTransferChellanOut(params)
                .then(function (res: any) {
                    that.isLoading = false;
                    if (res.success) {
                        swal(
                            'SUCCESS',
                            res.message,
                            'success'
                        );

                        //that.transferChellOutUpdateEvent.emit();
                        that.tcOutList = [];
                        that.tcOutData = [];
                        that.subscribeService.subReloadTcOutGrid();
                        that.subscribeService.subScribeDeleteActiveTab();
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });
        } else {
            let that = this;
            let params = {
                tcno: tcOutDet['tc_no'],
                out_type: tcOutDet['out_type'],
                companyid: tcOutDet['out_type'] !== 'HV Team' ? tcOutDet['company_id'] : 0,
                hv_userid: tcOutDet['out_type'] === 'HV Team' ? tcOutDet['hv_userid'] : 0,
                description: tcOutDet['description'] ? tcOutDet['description'] : '',
                tc_outdate: tcOutDate,
                particulars: tcFormDet,
                tc_out_id: tcOutDet['tc_out_id'],
                mode: 'Update',
                //from_branch: 1
            };
            this.isLoading = true;
            this.tcOutService.UpdateTransFerChellanOut(params)
                .then(function (res: any) {
                    that.isLoading = false;
                    if (res.success) {
                        swal(
                            'SUCCESS',
                            res.message,
                            'success'
                        );
                        //that.transferChellOutUpdateEvent.emit();
                        that.subscribeService.subReloadTcOutGrid();
                        that.subscribeService.subScribeDeleteActiveTab();
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });
        }

    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/transferChallanOut/addTransferChallanOut.component.ts